import { Api } from '@/api/Api'
import { ActionTree } from 'vuex'
import {
  RootState,
} from '../types'
import SecurityState from '../security/types'

import State, { ICustomerMultiplier } from './types'
const api = new Api()

export const actions: ActionTree<State, RootState> = {
  fetchCustomerMultipliers({ commit, rootState }, customerNumber: string): any {
    const url = `${rootState.apiPrefix ?? ''}/Customer/${customerNumber}/multipliers`
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        const result: ICustomerMultiplier = response.Data
        commit('customerMultipliersLoaded', result)
      })
      .catch(() => {
        commit('customerMultipliersError')
      })
  },
  clearCustomerMultipliers({ commit }) {
    commit('customerMultipliersCleared')
  },
}
